import SocialSignIn, { TEXT_TYPE } from './SocialSignIn';

export { TEXT_TYPE };
export default SocialSignIn;
